import { render } from "./OblissRoot.vue?vue&type=template&id=f325fbec"
import script from "./OblissRoot.vue?vue&type=script&lang=js"
export * from "./OblissRoot.vue?vue&type=script&lang=js"

import "./OblissRoot.vue?vue&type=style&index=0&id=f325fbec&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__